import { IconPhone } from './IconPhone'

export default IconPhone
